import { useState } from "react"
import Dialog from "@components/Dialog"
import type { DashboardChartDescriptionDto } from "@features/results/Result/Dashboard/dashboardModel"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { IconButton, Tooltip, Typography } from "@mui/material"

interface DashboardChartDescriptionButtonProps {
  description?: DashboardChartDescriptionDto
}

export function DashboardChartDescriptionButton({
  description,
}: DashboardChartDescriptionButtonProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  if (!description) {
    return null
  }

  return (
    <>
      <Tooltip title="Chart description">
        <IconButton
          data-testid="dashboard-chart-description-button"
          aria-label="Chart description"
          aria-haspopup="dialog"
          onClick={() => setIsDialogOpen(true)}
        >
          <InfoOutlinedIcon color="primary" />
        </IconButton>
      </Tooltip>

      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        closeOnBackdropClick
        title={description.Title}
        data-testid="dashboard-chart-description-dialog"
      >
        {description.Content.map((paragraph, index) => (
          <Typography
            key={`dashboard-chart-description-paragraph-${index}`}
            data-testid="dashboard-chart-description-paragraph"
            paragraph
          >
            {paragraph}
          </Typography>
        ))}
      </Dialog>
    </>
  )
}
